import { Injectable } from '@angular/core';
import type { UserWayEvent } from './accessibility.interface';

@Injectable({ providedIn: 'root' })
export class Accessibility {
  // Open UserWay external widget - https://userway.org
  openUserWayWidget(): void {
    const existingScript = document.getElementById('userWay-widget');
    if (!existingScript) {
      const script = document.createElement('script');
      script.setAttribute('id', 'userWay-widget');
      script.setAttribute('data-account', 'sGgJ6WxeqA');
      script.setAttribute('src', 'https://cdn.userway.org/widget.js');
      const firstScript = document.querySelector('script');
      document.head.insertBefore(script, firstScript);

      /* Open UserWay accessibility menu on init */

      document.addEventListener('userway:init_completed', e => {
        const event = e as UserWayEvent;
        const userwayInstance = event.detail.userWayInstance;
        if (userwayInstance) {
          userwayInstance.widgetOpen();
        } else {
          console.error('No UserWay instance found in payload');
        }
      });
    }
  }
}
